import React, { useEffect, useState } from 'react';
import { fetchHubupGroupInviteQr } from '../../api/hubup';

/**
 * QR invitation premium (généré côté serveur, logo communauté au centre).
 */
export default function HubupPremiumQr({
  groupId,
  inviteCode,
  groupIconUrl = '',
  faviconUrl = '',
  size = 200,
  className = '',
}) {
  const [qrImageUrl, setQrImageUrl] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  useEffect(() => {
    const code = String(inviteCode ?? '').trim();
    const gid = String(groupId ?? '').trim();
    if (!gid || !code) {
      setQrImageUrl('');
      setError('');
      return undefined;
    }

    let cancelled = false;
    setLoading(true);
    setError('');
    fetchHubupGroupInviteQr(gid)
      .then((res) => {
        if (cancelled) return;
        const url = res?.data?.qrImageUrl || '';
        setQrImageUrl(url);
        if (!url) setError('QR indisponible.');
      })
      .catch(() => {
        if (!cancelled) {
          setQrImageUrl('');
          setError('Impossible de charger le QR code.');
        }
      })
      .finally(() => {
        if (!cancelled) setLoading(false);
      });

    return () => {
      cancelled = true;
    };
  }, [groupId, inviteCode, groupIconUrl, faviconUrl]);

  if (loading && !qrImageUrl) {
    return (
      <div
        className={`flex items-center justify-center text-xs text-muted-foreground ${className}`}
        style={{ minHeight: size }}
      >
        Génération du QR…
      </div>
    );
  }

  if (error && !qrImageUrl) {
    return (
      <div
        className={`flex items-center justify-center text-xs text-muted-foreground text-center px-2 ${className}`}
        style={{ minHeight: size }}
      >
        {error}
      </div>
    );
  }

  if (!qrImageUrl) return null;

  return (
    <img
      src={qrImageUrl}
      alt="QR code d’invitation"
      className={`object-contain drop-shadow-sm ${className}`}
      style={{ width: size, height: size, maxWidth: '100%' }}
      draggable={false}
    />
  );
}
